import PropTypes from 'prop-types';
// import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Card, Stack, Chip, Avatar, Typography, Button, Tooltip, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// import { fCurrency } from '../../utils/formatNumber';
// components
import Label from '../../components/Label';
// import { ColorPreview } from '../../components/color-utils';
import Iconify from 'src/components/Iconify';
import { green } from '@mui/material/colors';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { handleResponse } from "src/utils/responseHandler"
import axios from 'src/axios'
import { getURL } from 'src/utils/config';
// ----------------------------------------------------------------------
const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});
// ----------------------------------------------------------------------

AuditListCard.propTypes = {
  audit: PropTypes.object,
};

function formatDate(datetimeString) {
  // Parse the datetime string into a Date object
  const date = new Date(datetimeString);

  // Extract the components of the date
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Construct the formatted date string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default function AuditListCard({ audit, handleDialog }) {
  // const [isSubmitting, setIsSubmitting] = useState(false)
  // const { EventNo, EventType,CameraId, ClientCreatedOn, DetectedType,EventTime, devicename, SnapshotUrl, VideoUrl ,SupervisorComments ,Priority } = audit;
  // const snapurl = SnapshotUrl !== null ? SnapshotUrl : `https://vdointel.online/vdointel/deviceimages/${CameraId}.jpg`
  const { EventNo, EventType,CameraId, ClientCreatedOn, DetectedType,EventTime, devicename, SnapshotUrl, snapshot, VideoUrl ,SupervisorComments ,Priority } = audit;
  const snapurl = SnapshotUrl !== null ? SnapshotUrl : snapshot !== null ?  snapshot : '';
  const IsAgentBased = localStorage.getItem('IsAgentBased');

  const formattedDate =EventTime?EventTime.replace('T', ' '):'';
  const latestFormattedDate =formattedDate?formatDate(formattedDate):'';
  const [showMore, setShowMore] = useState(false);
  //console.log("formattedDate",latestFormattedDate)
  // const sendMail = () => {
  //   setIsSubmitting(true)
  //     axios({
  //       method: 'get',
  //       url: getURL(`client-info/send-client-mail-consolidated?devicename=${devicename}&detectedtype=${DetectedType}&videourl=${VideoUrl}`),
  //       validateStatus: (status) => handleResponse(status),
  //   }).then(function (response) {
  //       setIsSubmitting(false)
  //       if (response.status === 200) {
  //         window.alert("Email has been sent successfully.")
  //       } else {
  //         window.alert("Something went wrong. Please try again later")
  //       }
  //   })
  // }

  const alignComments1 = (comments)=>{
    // console.log(comments)
    let lines=comments.split('\n')

    return (
      <ul>
        {lines.map((line, index) => (
          <li>
            {line}
          </li>
        ))}
      </ul>
    )
  }


  const alignComments = (comments) => {
    // console.log(comments);
  
    // Replace \n and \N with empty strings
    const cleanedComments = comments.replace(/\\n|\\N/g, '');
    const lines = cleanedComments.split('\n');
  
    return (
      <ul>
        {lines.map((line, index) => (
          <li key={index}>
            {line}
          </li>
        ))}
      </ul>
    );
  }
  

  return (
    <>
  {IsAgentBased === "0" ? (
    // <Card sx={{ p: 1}}>
    //     <div style={{ display: 'flex', width: '100%' }}>
    <Card sx={{ p: 1,    background:'#383838',
      height: '300px',
      boxShadow: 'none',}}>
        <div style={{ display: 'flex', width: '100%', height: '100%' }}>

        <Box onClick={() => handleDialog(audit)} 
          sx={{ 
            width: '50%',
            minHeight: 240, 
            position: 'relative', 
            // background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51 51 51))', 
            // cursor: "pointer" 
            background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51, 51, 51))',
            flexShrink: 0,
            cursor: 'pointer',
            borderRadius:'16px'
        }}
        >
                    
            <Avatar
              sx={{
                zIndex: 9,
                // top: '45%',
                // left: '45%',
                position: 'absolute',
                textTransform: 'uppercase',
                // bgcolor: green[500]
                color: '#2b6cb0',
                bgcolor: "#333666",
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 44,
                height: 44
              }}
            >
              <Iconify icon="eva:play-circle-outline" width={30} height={30} />
            </Avatar>
            {snapurl && (
              <ProductImgStyle alt={ClientCreatedOn} src={snapurl}  onError={(e) => {
                e.target.style.display = 'none';
              }} />
            )}
          </Box>
          <Box sx={{pt:1, pl:2, width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
          {/* <Typography color="gray" sx={{fontSize: "0.75rem"}}>{ClientCreatedOn}</Typography> */}
          {/* <Typography variant='h6' sx={{ fontSize: "1rem", textTransform: "capitalize" }}>{DetectedType}</Typography> */}
          <Stack direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            // sx={{pt: 1}}
            
            >
            <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Camera: </Typography>
          </Stack>
          <Stack direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            // sx={{pt: 1}}
            
            >
            <Typography sx={{ fontSize: "0.9rem", textTransform: "capitalize" }}>{devicename?devicename : ''} </Typography>
          </Stack>

          <Stack direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            
            >
            <Typography  sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Type: </Typography>
        
            
          </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
                    <Typography sx={{ fontSize: '0.9rem', wordBreak: 'break-word' }}>
                      {DetectedType ? DetectedType : ''}
                    </Typography>
            </Stack>


          <Stack direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      >
                      <Typography  sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Time : </Typography>
                  </Stack>
                  <Stack direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={1}
                      >
                      <Typography sx={{ fontSize: "0.9rem" }}>{latestFormattedDate ? latestFormattedDate :''}</Typography>
                  </Stack>

          <Stack direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            
            >
            <Typography  sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Number: </Typography>
            
          </Stack>
          <Stack direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            
            >
            <Typography sx={{ fontSize: "0.9rem" }}>{EventNo ? EventNo :''}</Typography>
            
          </Stack>
          

          {/* {Number(localStorage.getItem("client_id")) === 831 && (
            <LoadingButton 
            sx={{ mt: 2}}
            fullWidth
            variant="contained"
            loading={isSubmitting}
            onClick={sendMail}
            >
            Send Mail
            </LoadingButton>
          )}         */}
        </Box>

        </div> 
    </Card>

    ) : (
            
<Card sx={{     
    p: 1,
    mt: 1,
    background:'#383838',
    height: '300px',
    boxShadow: 'none',
 }}>
      <Grid container spacing={2} sx={{ flex: 1, height: '100%', mt:-1 }}>
        <Grid item xs={12} md={6}>
          <Box 
            onClick={() => handleDialog(audit)} 
            sx={{ 
              width: '100%',
              // position: 'relative', 
              // background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51 51 51))', 
              // cursor: "pointer",
              // height: { xs: 'auto', md: '100%' },
              height: '100%',
              position: 'relative',
              background: 'linear-gradient(to top, rgb(6, 6, 6), 20%, rgb(51 51 51))',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              borderRadius: '12px',
            }}
          >
            {/* <Avatar
              sx={{
                zIndex: 9,
                textTransform: 'uppercase',
                bgcolor: green[500]
              }}
            > */}
              {/* <Iconify icon="eva:play-circle-outline" width={30} height={30} />
            </Avatar> */}
            {snapurl && (
                            <Box
                            component="img"
                            alt={ClientCreatedOn}
                            src={snapurl}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                            sx={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        )}
                        <Avatar
                          sx={{
                            position: 'absolute',
                            zIndex: 9,
                            textTransform: 'uppercase',
                            color: '#2b6cb0',
                            bgcolor: "#333666",
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 44,
                            height: 44
                          }}
                        >
                          <Iconify icon="eva:play-circle-outline" width={30} height={30} />
                        </Avatar>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ width: '100%', p: 0, height: '100%' }}>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Camera: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem", textTransform: "capitalize" }}>{devicename ? devicename : ''}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Priority: </Typography>
              <Typography sx={{ fontSize: "0.9rem" }}>{Priority === 0 ? 'Normal' : 'High'}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Type: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}> {EventType ? EventType : ''}</Typography>
            </Stack>
        
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Time: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}>{latestFormattedDate ? latestFormattedDate : ''}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Event Number: </Typography>
            </Stack>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              <Typography sx={{ fontSize: "0.9rem" }}>{EventNo ? EventNo : ''}</Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} mt={-2}>
          <Box sx={{ p: 1 }}>
            <Typography sx={{ fontSize: "1.1rem", fontWeight: 800 }}>Comment:</Typography>
            <Typography component="div" sx={{ fontSize: "0.9rem", textTransform: "capitalize", ml: 1 }}>
              {alignComments(SupervisorComments ? SupervisorComments :'')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
   
         
    )}

    </>

  );
}
